import { useNavigate, useParams } from "react-router-dom";
import queryString from "query-string";
import { useFetcher } from "~/hooks/useFetcher";
import { ROUTE_404 } from "~/router/constants";
import { TableEntity } from "~/types/interfaces/catalogResponse";

const { VITE_CATALOG_API } = import.meta.env;

const useDatasetTable = (fqn?: string) => {
  const navigate = useNavigate();
  const { tableFQN = fqn } = useParams();
  const tableQueryString = queryString.stringify({
    fields: "description,columns,tags",
  });

  const resp = useFetcher<TableEntity>(
    tableFQN ? `${VITE_CATALOG_API}/om/v1/tables/name/${tableFQN}?${tableQueryString}` : null
  );

  if (resp.error?.status >= 400 && resp.error.status < 500) {
    navigate(ROUTE_404, { replace: true });
  }

  return resp;
};

export default useDatasetTable;
